export const DEFAULT_INPUT_PROFILE_CONFIG = {
  mode: 'CALLER',
  protocol: 'SRT',
  connection: [{ port: null, ip: '', passphrase: '' }],
  parameters: {
    latency: 200,
    bitrate: 19500000,
    routingScope: 'GLOBAL',
  },
};

export function createDefaultInputProfileConfig() {
  return JSON.stringify(DEFAULT_INPUT_PROFILE_CONFIG);
}

export function parseInputProfileConfig(value) {
  if (!value) return {};
  if (typeof value !== 'string') return value;
  try {
    return JSON.parse(value);
  } catch (error) {
    return {};
  }
}

// Known keys get form fields, everything else is preserved and stays reachable via the raw JSON editor.
export function normalizeInputProfileConfig(parsed = {}) {
  return {
    ...parsed,
    mode: parsed.mode || DEFAULT_INPUT_PROFILE_CONFIG.mode,
    protocol: parsed.protocol || DEFAULT_INPUT_PROFILE_CONFIG.protocol,
    connection: Array.isArray(parsed.connection) ? parsed.connection : [],
    parameters: {
      ...DEFAULT_INPUT_PROFILE_CONFIG.parameters,
      ...(parsed.parameters || {}),
    },
  };
}
